// extracted by mini-css-extract-plugin
export default {"base":"MSARiskMap_base__Smy8m","map_container":"MSARiskMap_map_container__gxVpO"};